import React, { useState, useEffect, memo } from 'react';
import { NotificacaoInterna } from '../../../../Services/Notification';
import { useHistory } from "react-router-dom";
import * as Styled from './style';
import apiAdonis from '../../../../Services/adonis';
import { DateInput } from "@blueprintjs/datetime";
import moment from 'moment';
import { Table1, Table2, HtmlBody } from './components';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import { Icon } from '@blueprintjs/core';

function App({ dados, url }: any) {
  const [getFormularioDataDeInicio, setFormularioDataDeInicio] = useState<any>();
  const [getFormularioDataDeTermino, setFormularioDataDeTermino] = useState<any>();
  const PropriedadesDeCalendario = {
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    weekdaysShort: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
  };

  const History = useHistory();
  async function VerifyToken() {

    await apiAdonis.post('/verify', {}, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    }).then(async result => {
      if (result.data.check) {
        return null
      }
      else {
        NotificacaoInterna.ExibirNotificacao("Acesso Expirado!", "Seu acesso à aplicação foi expirado!", NotificacaoInterna.TipoDeNotificacao.Informacao);
        History.replace("/");
        window.location.reload();
      }
    });
  }

  useEffect(() => {
    async function componentDidMount() {
      await VerifyToken();
    }
    componentDidMount();
  }, [dados])
  return (
    <>
      <Styled.Container>
        {/* NAVBAR */}
        <Styled.Navbar>
          <Styled.DateInputs>
            <span>PERÍODO:</span>
            <div style={{ width: "35%" }}>
              <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                placeholder={"Data Início"} value={getFormularioDataDeInicio} maxDate={getFormularioDataDeTermino}
                onChange={async (DataSelecionada: Date) => {
                  if (DataSelecionada != null) {
                    await setFormularioDataDeInicio(DataSelecionada)
                  }
                  else {
                    await setFormularioDataDeInicio(getFormularioDataDeInicio)
                  }
                }}>
              </DateInput>
            </div>
            <div style={{ width: "35%" }}>
              <DateInput dayPickerProps={PropriedadesDeCalendario} formatDate={(date, locale) => moment(date).locale(moment.locale(locale)).format("DD/MM/YYYY")}
                parseDate={(str, locale) => moment(str, "DD/MM/YYYY").locale(moment.locale(locale)).toDate()}
                placeholder={"Data Final"} value={getFormularioDataDeTermino} minDate={getFormularioDataDeInicio}
                onChange={async (DataSelecionada: Date) => {
                  if (DataSelecionada != null) {
                    await setFormularioDataDeTermino(DataSelecionada)
                  }
                  else {
                    await setFormularioDataDeTermino(getFormularioDataDeTermino)
                  }
                }}>
              </DateInput>
            </div>
          </Styled.DateInputs>
          <Styled.Total>
            <span>TOTAL:</span>
            <span style={{ fontWeight: "bold", fontSize: "13px" }}>10.000</span>
            <span style={{ fontSize: "10px" }}>apenas vencidos.</span>
          </Styled.Total>
        </Styled.Navbar>
        {/* BODY */}
        <Styled.InfoNonTables>
          {/* CONTAS A PAGAR */}
          <Styled.InfoCard>
            <HtmlBody.InfoTitleCard
              label='CONTAS A PAGAR'
              title_type={0} />

            <Styled.InfoCardTables>
              <HtmlBody.InfoCard
                label='AUTORIZADO'
                first_date='31/12/2021'
                first_value={100000}
                first_percent='50%'
                second_date='01/01/2021'
                second_value={100000}
                second_percent='50%'
                venc_value={100000}
                venc_percent='50%'
              />
              <HtmlBody.InfoCard
                label='NÃO AUTORIZADO'
                first_date='31/12/2021'
                first_value={100000}
                first_percent='50%'
                second_date='01/01/2021'
                second_value={100000}
                second_percent='50%'
                venc_value={100000}
                venc_percent='50%'
              />
            </Styled.InfoCardTables>
          </Styled.InfoCard>
          {/* TESOURARIA */}
          <Styled.InfoCard>
            <HtmlBody.InfoTitleCard
              label='TESOURARIA'
              title_type={0} />

            <Styled.InfoCardTables>
              <HtmlBody.InfoCard
                label='CONCILIADO'
                first_date='31/12/2021'
                first_value={100000}
                first_percent='50%'
                second_date='01/01/2021'
                second_value={100000}
                second_percent='50%'
                venc_value={100000}
                venc_percent='50%'
              />
              <HtmlBody.InfoCard
                label='NÃO CONCILIADO'
                first_date='31/12/2021'
                first_value={100000}
                first_percent='50%'
                second_date='01/01/2021'
                second_value={100000}
                second_percent='50%'
                venc_value={100000}
                venc_percent='50%'
              />
            </Styled.InfoCardTables>
          </Styled.InfoCard>
          {/* PROGRAMAÇÃO */}
          <Styled.InfoCard >
            <HtmlBody.InfoTitleCard
              label='PROGRAMAÇÃO'
              sub_label='(relevância)'
              title_type={1} />

            <div style={{ width: "100%", height: "90%", display: "flex", flexDirection: "column", alignItems: "space-center", justifyContent: "space-between" }}>
              <div style={{ width: "100%", minWidth: "225px", minHeight: "105px", height: "8vw", background: "white", borderBottom: "1px solid #D9D9D9" }}>
                <ReactEChartsCore
                  echarts={echarts}
                  option={{
                    width: "90%",
                    height: "130px",
                    responsive: false,
                    maintainAspectRatio: false,
                    grid: {
                      containLabel: true,
                      top: '8%',
                      left: "5%"
                    },
                    yAxis: [
                      {
                        type: 'category',
                        data: ['ONTEM', 'HOJE', 'AMANHÃ'],
                        axisTick: {
                          show: false
                        },
                        axisLabel: {
                          textStyle: {
                            color: '#7b7e91'
                          }
                        }
                      },
                      {
                        type: 'category',
                        data: [1, 1, 2],
                        axisLine: {
                          show: false
                        },
                        axisTick: {
                          show: false
                        },
                        axisLabel: {
                          textStyle: {
                            color: '#494d63',
                            fontSize: "bold"
                          }
                        }
                      }
                    ],

                    xAxis: [
                      {
                        show: false,
                        type: 'value',
                        splitLine: {
                          show: false
                        }
                      }
                    ],
                    series: [
                      {
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                          color: 'rgba(220, 220, 220, 0.8)'
                        },
                        data: [
                          {
                            value: 1,
                            itemStyle: {
                              color: "#FF7B7B"
                            }
                          },
                          {
                            value: 2,
                            itemStyle: {
                              color: "#FFC343"
                            }
                          },
                          {
                            value: 3,
                            itemStyle: {
                              color: "#93D66D"
                            }
                          }
                        ],
                        barWidth: "20%"
                      }
                    ]
                  }}
                />
              </div>
              <div style={{ width: "100%", minWidth: "225px", minHeight: "105px", height: "8vw", background: "white", borderBottom: "1px solid #D9D9D9" }}>
                <ReactEChartsCore
                  echarts={echarts}
                  option={{
                    width: "90%",
                    height: "130px",
                    responsive: false,
                    maintainAspectRatio: false,
                    color: ['#3398DB'],
                    grid: {
                      containLabel: true,
                      top: '8%',
                      left: "5%"
                    },
                    yAxis: [
                      {
                        type: 'category',
                        data: ['ONTEM', 'HOJE', 'AMANHÃ'],
                        axisTick: {
                          show: false
                        },
                        axisLabel: {
                          textStyle: {
                            color: '#7b7e91'
                          }
                        }
                      },
                      {
                        type: 'category',
                        data: [1, 1, 2],
                        axisLine: {
                          show: false
                        },
                        axisTick: {
                          show: false
                        },
                        axisLabel: {
                          textStyle: {
                            color: '#494d63',
                            fontSize: "bold"
                          }
                        }
                      }
                    ],

                    xAxis: [
                      {
                        show: false,
                        type: 'value',
                        splitLine: {
                          show: false
                        }
                      }
                    ],
                    series: [
                      {
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                          color: 'rgba(220, 220, 220, 0.8)'
                        },
                        data: [
                          {
                            value: 1,
                            itemStyle: {
                              color: "#FF7B7B"
                            }
                          },
                          {
                            value: 2,
                            itemStyle: {
                              color: "#FFC343"
                            }
                          },
                          {
                            value: 3,
                            itemStyle: {
                              color: "#93D66D"
                            }
                          }
                        ],
                        barWidth: "20%"
                      }
                    ]
                  }}
                />
              </div>
            </div>
          </Styled.InfoCard>
          {/* PROGRAMAÇÃO */}
          <Styled.InfoCard style={{ width: "10%", minWidth: "125px" }}>
            <HtmlBody.InfoTitleCard
              label='PROGRAMAÇÃO'
              sub_label='(relevância)'
              title_type={1} />

            <HtmlBody.InfoRelevCard
              first_label='ONTEM'
              first_value="100000"
              second_label='HOJE'
              second_value="100000"
              third_label='AMANHÃ'
              third_value="100000"
              font_size='15px'
            />
          </Styled.InfoCard>
          {/* EFICIÊNCIA */}
          <Styled.InfoCard>
            <HtmlBody.InfoTitleCard
              label='EFICIÊNCIA'
              title_type={0} />

            <HtmlBody.InfoRelevCard
              first_label='CONTAS A PAGAR'
              first_value="Há pagamentos vencidos que não foram autorizados, necessário verificação."
              second_label='CONTAS A PAGAR'
              second_value="Há pagamentos vencidos que não foram autorizados, necessário verificação."
              third_label='FINANCEIRO'
              third_value="Há pagamentos vencidos que não foram autorizados, necessário verificação."
              font_size='13px'
            />
          </Styled.InfoCard>
        </Styled.InfoNonTables>
        <Styled.TablesCard>
          <div style={{ width: "20%", minWidth: "210px", height: "650px", margin: "30px auto", display: "flex", alignItems: "center", justifyContent: "center", background: "#fafafa", borderRadius: "5px" }}>
            <Table1></Table1>
          </div>
          <div style={{ width: "76%", minWidth: "400px", margin: "30px auto", display: "flex", alignItems: "center", justifyContent: "center", background: "#fafafa", borderRadius: "5px" }}>
            <Table2></Table2>
          </div>
        </Styled.TablesCard>
      </Styled.Container>
    </>
  );
}

export default memo(App);